import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tag } from '@instructure/ui-tag';
import { AccessibleContent } from '@instructure/ui-a11y-content';
import t from '@instructure/quiz-i18n/format-message';
export var TagWrapper = /*#__PURE__*/function (_Component) {
  function TagWrapper() {
    var _this2;
    _classCallCheck(this, TagWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, TagWrapper, [].concat(args));
    _defineProperty(_this2, "dismissTag", function (e) {
      // prevent closing of list
      e.stopPropagation();
      e.preventDefault();
      _this2.props.onClick(_this2.props.id);
    });
    return _this2;
  }
  _inherits(TagWrapper, _Component);
  return _createClass(TagWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        id = _this$props.id,
        text = _this$props.text,
        index = _this$props.index,
        themeOverride = _this$props.themeOverride;
      return /*#__PURE__*/React.createElement(Tag, {
        text: /*#__PURE__*/React.createElement(AccessibleContent, {
          alt: t('Remove {label}', {
            label: text
          })
        }, text),
        dismissible: true,
        key: id,
        margin: index > 0 ? 'xxx-small 0 xxx-small xx-small' : 'xxx-small 0',
        onClick: this.dismissTag,
        themeOverride: themeOverride
      });
    }
  }]);
}(Component);
_defineProperty(TagWrapper, "propTypes", {
  text: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  themeOverride: PropTypes.object
});
_defineProperty(TagWrapper, "defaultProps", {
  themeOverride: {}
});
export default TagWrapper;